import { render, staticRenderFns } from "./AddActivityBoosters.vue?vue&type=template&id=33aa40c4"
import script from "./AddActivityBoosters.vue?vue&type=script&lang=js"
export * from "./AddActivityBoosters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports